import UrlUtil from 'utils/UrlUtil';
import queryString from 'query-string';
import { BOT_USER_ID, NONE_USER_ID } from 'constants/UserConstants';

function getUserIds(location) {
  const parsed = queryString.parse(location.search);
  const leftUserID = parsed.left;
  const rightUserID = parsed.right;
  return {leftUserID, rightUserID};
}

function parseUserId(userId) {
  // Handle the special bot and none user IDs - return as-is
  if (userId === BOT_USER_ID || userId === NONE_USER_ID) {
    return userId;
  }
  // Parse numeric IDs — STRICTLY. A malformed value returns null so the
  // redirect below replaces it with a default instead of rendering a
  // silently-empty all-one-sided comparison. parseInt alone was not enough:
  // its prefix parsing let '12abc' through as 12 and '0x1F' as 31, dodging
  // the redirect and matching either no coder or the wrong one.
  if (typeof userId === 'number' && Number.isInteger(userId)) return userId;
  if (typeof userId === 'string' && /^\d+$/.test(userId)) return parseInt(userId, 10);
  return null;
}

// A usable ?left=/?right= value: one of the special ids, or something
// numeric. Anything else is treated exactly like a missing param, so
// redirectComparisonUrl replaces it with the default instead of letting a
// mangled URL drive an empty (and misleading) comparison.
function isValidUserParam(userId) {
  return !!userId && parseUserId(userId) !== null;
}

var ComparisonUrlUtil = {
  getUserIds,
  parseUserId,
  redirectComparisonUrl: function(location, isLoaded, owner, collaborators, hasBotExcerpts = false) {
    const {leftUserID, rightUserID} = getUserIds(location);
    const leftValid = isValidUserParam(leftUserID);
    const rightExist = isValidUserParam(rightUserID) && rightUserID !== NONE_USER_ID;

    if ( leftValid && !!rightExist ) return null;
    if ( !isLoaded ) return null;
    const ownerId = (owner || {}).id;

    if ( !ownerId ) return null;
    const collaboratorId = hasBotExcerpts ? BOT_USER_ID : ((collaborators[0] || {}).id || NONE_USER_ID);

    if ( leftUserID === ownerId.toString() && rightUserID === collaboratorId.toString() ) return null;

    const url = UrlUtil.addParamsToUrlObject(location, {
      ...(!leftValid && !!ownerId ? {left: ownerId} : {}),
      ...(!rightExist && !!collaboratorId ? {right: collaboratorId} : {})
    })

    return url;
  },
}

export default ComparisonUrlUtil;
